export const getTemplateId = template => {
  return typeof template === 'number' ? template : template.id;
};